import { useTranslation } from "react-i18next"
import { Brush, Glasses, Rotate3d, type LucideIcon } from "lucide-react"
import { type HomeCategoryKey } from "services/adminApi"

export interface SelectableCategoryOption {
  group: "3d" | "tryon"
  hintKey: string
  icon: LucideIcon
  key: HomeCategoryKey
  labelKey: string
}

export const SELECTABLE_OPTIONS: SelectableCategoryOption[] = [
  {
    group: "tryon",
    hintKey: "home.onboarding.categories.makeupHint",
    icon: Brush,
    key: "makeup",
    labelKey: "home.onboarding.categories.makeup",
  },
  {
    group: "tryon",
    hintKey: "home.onboarding.categories.glassesHint",
    icon: Glasses,
    key: "glasses",
    labelKey: "home.onboarding.categories.glasses",
  },
  {
    group: "3d",
    hintKey: "home.onboarding.categories.viewer3dHint",
    icon: Rotate3d,
    key: "viewer3d",
    labelKey: "home.onboarding.categories.viewer3d",
  },
]

export const CATEGORY_ICONS: Record<HomeCategoryKey, LucideIcon> = {
  glasses: Glasses,
  makeup: Brush,
  viewer3d: Rotate3d,
}

export const CategoryOptionRow = ({ option }: { option: SelectableCategoryOption }) => {
  const { t } = useTranslation()
  const Icon = option.icon

  return (
    <span className="flex items-center gap-3">
      <span className="flex size-9 shrink-0 items-center justify-center rounded-full bg-muted">
        <Icon className="size-4" aria-hidden />
      </span>
      <span className="flex flex-col items-start">
        <span className="text-sm font-medium">{t(option.labelKey)}</span>
        <span className="text-xs text-muted-foreground">{t(option.hintKey)}</span>
      </span>
    </span>
  )
}
